import { FC } from 'react'
import Shipment from '../../../../../types/api/shipment'
import MachineBrandWrapper from '../../../../../components/form-items/machine-brand-wrapper/machine-brand-wrapper'

interface ShipmentMachineBrandWrapperProps {
    record?: Pick<Shipment, 'stamp'>
}

const ShipmentMachineBrandWrapper: FC<ShipmentMachineBrandWrapperProps> = ({ record }) => {
    return <MachineBrandWrapper record={record} />
}

export default ShipmentMachineBrandWrapper
